import { atom } from 'recoil';

export const impersonateData = atom({
  key: 'impersonateData',
  default: null,
  effects: [
    ({ setSelf, onSet }) => {
      const storedImpersonate = sessionStorage.getItem('impersonate');
      const storedBusiness = sessionStorage.getItem('business');
      const storedToken = sessionStorage.getItem('token');
      const storedBusinessName = sessionStorage.getItem('businessName');
      const storedBusinessDetails = JSON.parse(sessionStorage.getItem('businessDetails'));
      if (!storedImpersonate || !storedBusiness || !storedToken) {
        setSelf(null);
      } else {
        setSelf({
          business: storedBusiness || '',
          impersonate: true,
          token: storedToken || '',
          businessName: storedBusinessName || '',
          businessDetails: storedBusinessDetails || {},
        });
      }
    },
  ],
});
